// extracted by mini-css-extract-plugin
export default {"navbar":"menu_navbar__DS5Ld","navigation":"menu_navigation__S6joB","overlay":"menu_overlay__dvz8L","active":"menu_active__oHs6Q","open":"menu_open__kPERq"};